import type { Mode } from '../lib/mode';

// The Quick / Pro switch in the top bar. Two segments, one pressed: a
// creator reads which door they are behind at a glance, and the other
// segment says where the switch goes. It announces state through
// aria-pressed rather than colour alone, because the two segments are the
// same shape and colour is the only thing a screen reader cannot see.
//
// It does not remember anything itself. App owns the mode, writes it, and
// decides which view the switch lands on — this is the control, not the rule.
export function ModeSwitch({ mode, onChange }: { mode: Mode; onChange: (m: Mode) => void }) {
  return (
    <div className="modeswitch" role="group" aria-label="Studio">
      <button type="button" aria-pressed={mode === 'quick'} onClick={() => onChange('quick')}
              title="Six tabs, one prompt each, the price on the button.">Quick</button>
      <button type="button" aria-pressed={mode === 'pro'} onClick={() => onChange('pro')}
              title="Every bench with every control on it.">Pro</button>
    </div>
  );
}
